// extracted by mini-css-extract-plugin
export default {"signature":"Signature_signature__8iVHz","placeholder":"Signature_placeholder__uXLw3"};